import Vue from 'vue'
import types from './mutation-types'

export default {
  [types.UPDATE_APP_PRODUCTCODE] (state, value) {
    state.app.productCode = value
  },
  [types.UPDATE_APP_INNERCODE] (state, value) {
    state.app.innerCode = value
  },
  [types.UPDATE_APP_H5] (state, value) {
    state.app.h5 = value
  },

  [types.UPDATE_ORDER_UNIONCODE] (state, value) {
    state.order.unionCode = value
  },

  [types.UPDATE_ORDER_CONFIRMFEEDBACK] (state, value) {
    state.order.confirmFeedback = value
  },

  [types.UPDATE_ORDER_OFFLINECODE] (state, value) {
    state.order.offlineCode = value
  },

  [types.UPDATE_MEASURESUCCESS] (state, value) {
    state.measure.success = value
  },

  [types.UPDATE_BASEPREMIUM] (state, value) {
    state.measure.basePremium = value
  },

  [types.UPDATE_BASEBACKMONEY] (state, value) {
    state.measure.baseBackMoney = value
  },

  [types.UPDATE_FEESUCCESS] (state, value) {
    state.order.feeSuccess = value
  },

  [types.UPDATE_CONFIG] (state, value) {
    for (let key in value) {
      Vue.set(state.config, key, value[key])
    }
    // 设置表单的store
    if (state.config.form) {
      for (let key in state.config.form) {
        switch (key) {
          // 给谁投保
          case 'insuredRelations':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value)
                break
              }
            }
            break
          case 'birthday':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'sexs':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value)
                break
              }
            }
            break
          case 'coverages':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value)
                break
              }
            }
            break
          case 'paymentPeriods':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value)
                break
              }
            }
            break
          case 'insurancePeriods':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value.value)
                break
              }
            }
            break
          case 'paymentWays':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value)
                break
              }
            }
            break
          case 'paymentModes':
            for (let i = 0, l = state.config.form[key].list.length; i < l; i++) {
              if (state.config.form[key].list[i].default) {
                Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].list[i].value)
                break
              }
            }
            break
          case 'mild':
            Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].value)
            break
          case 'insuredName':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'insuredIDNumber':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'isInsuredIDLongTerm':
            Vue.set(state.order, state.config.form[key].storeKey, true)
            break
          case 'insuredIDBeginTerm':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'insuredIDEndTerm':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'insuredHeight':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'insuredWeight':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderName':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderPhone':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderPhoneCAPTCHA':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderEmail':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderArea':
            Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].default || [])
            break
          case 'holderAddress':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderIDNumber':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'isHolderIDLongTerm':
            Vue.set(state.order, state.config.form[key].storeKey, true)
            break
          case 'holderIDBeginTerm':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderIDEndTerm':
            Vue.set(state.order, state.config.form[key].storeKey, '')
            break
          case 'holderOccupation':
            Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].default)
            break
          case 'insuredOccupation':
            Vue.set(state.order, state.config.form[key].storeKey, state.config.form[key].default)
            break
        }
      }
    }
  },

  [types.UPDATE_BANKSFROMSERVER] (state, value) {
    state.config.banksFromServer = value
  },

  [types.UPDATE_RAWBANKSFROMSERVER] (state, value) {
    state.config.rawBanksFromServer = value
  },

  [types.UPDATE_INSUREDRELATION] (state, value) {
    state.order.insuredRelation = value
  },

  [types.UPDATE_BIRTHDAY] (state, value) {
    state.order.birthday = value
  },

  [types.UPDATE_SEX] (state, value) {
    state.order.sex = value
  },

  [types.UPDATE_COVERAGE] (state, value) {
    state.order.coverage = value
  },

  [types.UPDATE_PAYMENTPERIOD] (state, value) {
    state.order.paymentPeriod = value
  },

  [types.UPDATE_INSURANCEPERIOD] (state, value) {
    state.order.insurancePeriod = value
  },

  [types.UPDATE_PAYMENTWAY] (state, value) {
    state.order.paymentWay = value
  },

  [types.UPDATE_ORDER_PAYMENTMODE] (state, value) {
    state.order.paymentMode = value
  },

  [types.UPDATE_MILD] (state, value) {
    state.order.mild = value
  },

  [types.UPDATE_INSUREDNAME] (state, value) {
    state.order.insuredName = value
  },

  [types.UPDATE_INSUREDIDNUMBER] (state, value) {
    state.order.insuredIDNumber = value
  },

  [types.UPDATE_INSUREDHEIGHT] (state, value) {
    state.order.insuredHeight = value
  },

  [types.UPDATE_INSUREDWEIGHT] (state, value) {
    state.order.insuredWeight = value
  },

  [types.UPDATE_ISINSUREDIDLONGTERM] (state, value) {
    state.order.isInsuredIDLongTerm = value
  },

  [types.UPDATE_INSUREDIDBEGINTERM] (state, value) {
    state.order.insuredIDBeginTerm = value
  },

  [types.UPDATE_INSUREDIDENDTERM] (state, value) {
    state.order.insuredIDEndTerm = value
  },

  [types.UPDATE_INSUREDOCCUPATION] (state, value) {
    state.order.insuredOccupation = value
  },

  [types.UPDATE_HOLDERNAME] (state, value) {
    state.order.holderName = value
  },

  [types.UPDATE_HOLDERPHONE] (state, value) {
    state.order.holderPhone = value
  },

  [types.UPDATE_HOLDERPHONECAPTCHA] (state, value) {
    state.order.holderPhoneCAPTCHA = value
  },

  [types.UPDATE_HOLDEREMAIL] (state, value) {
    state.order.holderEmail = value
  },

  [types.UPDATE_HOLDERAREA] (state, value) {
    state.order.holderArea = value
  },

  [types.UPDATE_HOLDERADDRESS] (state, value) {
    state.order.holderAddress = value
  },

  [types.UPDATE_HOLDERIDNUMBER] (state, value) {
    state.order.holderIDNumber = value
  },

  [types.UPDATE_ISHOLDERIDLONGTERM] (state, value) {
    state.order.isHolderIDLongTerm = value
  },

  [types.UPDATE_HOLDERIDBEGINTERM] (state, value) {
    state.order.holderIDBeginTerm = value
  },

  [types.UPDATE_HOLDERIDENDTERM] (state, value) {
    state.order.holderIDEndTerm = value
  },

  [types.UPDATE_HOLDEROCCUPATION] (state, value) {
    state.order.holderOccupation = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js